import React from "react";
import { getFoodList } from "../api/food";
import { toast } from "react-toastify";
import DietMeal from "./DietMeal";
import Select from 'react-select'

class DietFood extends React.Component {
    state = {
        food: [],
        selectedFood: null,
    };

    async componentDidMount() {
        // This binding is necessary to make `this` work in the callback
        this.handleOmitClicked = this.handleOmitClicked.bind(this);
        this.handleLockPortionClicked = this.handleLockPortionClicked.bind(this);
        this.handlePortionChange = this.handlePortionChange.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.handleItemDeleted = this.handleItemDeleted.bind(this);
        this.handleSelected = this.handleSelected.bind(this);
        await this.getFood();
    }

    selMealTimeRef = React.createRef();

    getMealIDs(mealQty) {
        let tot = [1, 2, 3];

        switch (mealQty) {
            case 3:
                break;
            case 4:
                tot.push(6);
                break;
            case 5:
                tot.push(6);
                tot.push(4);
                break;
            case 6:
                tot.push(4);
                break;
            case 7:
                tot.push(4);
                tot.push(5);
                break;
            default:
                throw new Error("Not expected mealQty value");
        }
        return tot;
    }

    async getFood() {
        try {
            this.setState({ food: await getFoodList() });
        } catch {
            toast.error("Error al obtener lista de alimentos");
        }
    }

    handleSelected(food) {
        if (food)
            this.setState({ selectedFood: food });
        else
            this.setState({ selectedFood: null });
    }

    getMealFoodList(mealTime) {
        return this.props.diet.foodList.filter(f => f.mealTime === mealTime);
    }
    getMealControl(mealTime) {
        //debugger;
        if (this.props.diet.mealsControl) return this.props.diet.mealsControl.filter(m => m.mealTime === mealTime)[0];
        else return null;
    }

    handleOmitClicked(food) {
        var array = [...this.props.diet.foodList]; // make a separate copy of the array
        var index = array.findIndex(f => f.foodId === food.foodId && f.mealTime === food.mealTime);
        if (index !== -1) {
            let food = array[index];
            food.omit = !food.omit;
            if (food.omit) food.lockedPortion = false;
            const updatedDiet = { ...this.props.diet, foodList: array };

            this.props.updateDiet(updatedDiet, true);
        }
    }

    handleLockPortionClicked(food) {
        var array = [...this.props.diet.foodList]; // make a separate copy of the array
        var index = array.findIndex(f => f.foodId === food.foodId && f.mealTime === food.mealTime);
        if (index !== -1) {
            let food = array[index];
            food.lockedPortion = !food.lockedPortion;
            const updatedDiet = { ...this.props.diet, foodList: array };

            if (food.lockedPortion) this.props.updateDiet(updatedDiet);
            else this.props.updateDiet(updatedDiet, true);
        }
    }

    /**
    * Called everytime a portion input is changed, every character typed
    * @param {Object} event event object to get target
    * @param {Object} food food object
    * @param {Number} type type of change 1: locked portion 2: min input 3: max input
    */
    handlePortionChange(event, food, type) {
        //let value = parseFloat(event.target.value);
        //if (isNaN(value)) 
           let value = event.target.value;
        this.updatePortionValue(value, food, type);
    }

    /**
    * Updates a portion value
    * @param {Object} value new value
    * @param {Object} food food object
    * @param {Number} type type of portion to update 1: locked portion, 2: min input, 3: max input
    */
    updatePortionValue(value, food, type) {
        var array = [...this.props.diet.foodList]; // make a separate copy of the array
        var index = array.findIndex(f => f.foodId === food.foodId && f.mealTime === food.mealTime);
        if (index !== -1) {
            switch (type) {
                case 1:
                    array[index].dietPortion = value;
                    break;
                case 2:
                    array[index].minPortion = value;
                    break;
                case 3:
                    array[index].maxPortion = value;
                    break;
                default:
                    throw new Error("Portion type not implemented.");
            }
            const updatedDiet = { ...this.props.diet, foodList: array };
            this.props.updateDiet(updatedDiet);
        }
    }

    /**
    * Called when portion input has finished changing
    * @param {Object} event event object to get target
    * @param {Object} food food object
    * @param {Number} type type of change 1: locked portion 2: min input 3: max input
    */
    handleChangeEnd(event, food, type) {
        let value = parseFloat(event.target.value);
        if (isNaN(value)) {
            toast.error("Cantidad no valida");

            if (type === 2 || type === 3)// since min and max input hide on lost focus it is better to set them to 0 when they are not a number
                this.updatePortionValue(0, food, type);
            else {
                // simulates keyup event to set portionChanged so blur gets executed next time and avoid losing focus if not a valid number
                const e = new Event('keyup', { bubbles: true });
                event.target.dispatchEvent(e);
            }
            event.target.focus();
            event.target.select();
        } else {
            this.updatePortionValue(value, food, type);
            switch (type) {
                case 1:
                    break;
                case 2:
                    if (value > food.maxPortion) {
                        toast.warn("El valor minimo debe ser menor al maximo");
                        return;
                    }
                    break;
                case 3:
                    if (value < food.minPortion) {
                        toast.warn("El valor maximo debe ser mayor al minimo");
                        return;
                    }
                    break;
                default:
                    throw new Error("Portion type not implemented.");
            }
            this.props.refreshDiet();
        }
    }

    handleItemDeleted(food) {
        var array = [...this.props.diet.foodList]; // make a separate copy of the array
        var index = array.findIndex(f => f.foodId === food.foodId && f.mealTime === food.mealTime);
        if (index !== -1) {
            array.splice(index, 1);
            const updatedDiet = { ...this.props.diet, foodList: array };

            this.props.updateDiet(updatedDiet, true);
        }
    }

    getTot() {
        let totCarbs = 0,
            totProts = 0,
            totFats = 0,
            totCals = 0,
            totFib = 0,
            totSod = 0;

        for (var i = 0; i < this.props.diet.foodList.length; i++) {
            totCarbs += this.props.diet.foodList[i].carbs;
            totProts += this.props.diet.foodList[i].prots;
            totFats += this.props.diet.foodList[i].fats;
            totCals += this.props.diet.foodList[i].cals;
            totFib += this.props.diet.foodList[i].fib;
            totSod += this.props.diet.foodList[i].sod;
        }
        return {
            carbs: totCarbs.toFixed(2),
            prots: totProts.toFixed(2),
            fats: totFats.toFixed(2),
            cals: totCals.toFixed(2),
            fib: totFib.toFixed(2),
            sod: totSod.toFixed(2)
        };
    }

    render() {
        return (
            <>
                <div className="row mb-2">
                    <label className="col-sm-3 col-lg-2 col-form-label">Agrega alimentos:</label>
                    <div className="col-sm-5 col-lg-5">
                        <Select options={this.state.food} isClearable="true" isSearchable="true" placeholder="Buscar..." onChange={this.handleSelected} />
                    </div>
                    <label className="col-sm-1 col-lg-1 col-form-label">Tiempo</label>
                    <div className="col-sm-2 col-lg-2">
                        <select ref={this.selMealTimeRef} className="form-select">
                            <option value="1">Desayuno</option>
                            <option value="2">Comida</option>
                            <option value="3">Cena</option>
                            {this.props.mealQty > 3 && this.props.mealQty < 6 && <option value="6">Almuerzo</option>}
                            {this.props.mealQty > 4 && <option value="4">Colacion</option>}
                            {this.props.mealQty > 6 && <option value="5">Colacion 2</option>}
                        </select>{" "}
                    </div>
                    <div className="col-sm-1 col-lg-1">
                        <input
                            type="button"
                            className="btn btn-primary"
                            value="Agregar"
                            onClick={() => {
                                if (this.state.selectedFood) {
                                    let newFood = {
                                        foodId: this.state.selectedFood.value,
                                        foodName: this.state.selectedFood.label,
                                        mealTime: Number(this.selMealTimeRef.current.value),
                                        minPortion: 0,
                                        maxPortion: 0,
                                        carbs: 0,
                                        fats: 0,
                                        prots: 0
                                    };
                                    var index = this.props.diet.foodList.findIndex(f => f.foodId === newFood.foodId && f.mealTime === newFood.mealTime);
                                    if (index !== -1) {
                                        toast.error("Error. Ese alimento ya se encuentra en la comida");
                                    }
                                    else {
                                        var array = [...this.props.diet.foodList, newFood]; // make a separate copy of the array
                                        const updatedDiet = { ...this.props.diet, foodList: array };
                                        this.props.updateDiet(updatedDiet, true);
                                    }
                                }
                                else
                                    toast.error("No hay ningun alimento seleccionado");
                            }}
                        />
                    </div>
                </div>
                <table className="table table-sm table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th style={{ width: "5px" }} />
                            <th style={{ width: "57px", minWidth: "57px" }} />
                            <th style={{ minWidth: "200px" }}>Alimento</th>
                            <th style={{ width: "365px", minWidth: "365px" }}>Porcion</th>
                            <th style={{ width: "57px" }} />
                            <th>Carbs</th>
                            <th>Grasas</th>
                            <th>Prots</th>
                            {this.props.showAllData && (
                                <>
                                    <th>Calorias</th>
                                    <th>Fibra</th>
                                    <th>Sodio</th>
                                </>
                            )}
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {this.getMealIDs(this.props.diet.mealQty).map(mealId => {
                            return (
                                <DietMeal
                                    key={mealId}
                                    mealTime={mealId}
                                    foodList={this.getMealFoodList(mealId)}
                                    mealCtrl={this.getMealControl(mealId)}
                                    onOmitClicked={this.handleOmitClicked}
                                    onLockPortionClicked={this.handleLockPortionClicked}
                                    onPortionChange={this.handlePortionChange}
                                    onDeleteClicked={this.handleItemDeleted}
                                    onChangeEnd={this.handleChangeEnd}
                                    showAllData={this.props.showAllData}
                                />
                            );
                        })}
                        <tr className="table-dark" style={{fontWeight: "bold"}}>
                            <td colSpan="5">Totals</td>
                            <td>{this.getTot().carbs}</td>
                            <td>{this.getTot().fats}</td>
                            <td>{this.getTot().prots}</td>
                            {this.props.showAllData && (
                                <>
                                    <td>{this.getTot().cals}</td>
                                    <td>{this.getTot().fib}</td>
                                    <td>{this.getTot().sod}</td>
                                </>
                            )}
                            <td />
                        </tr>
                    </tbody>
                </table>
            </>
        );
    }
}

export default DietFood;
